import {Component, Inject, OnInit, ViewChild, ViewContainerRef} from '@angular/core';
import {UserService} from '../../../services/users-service/user-service';
import {Router} from '@angular/router';
import {AuthService} from '../../../services/auth-service/auth-service.service';
import {ErrorService} from '../../../util/error_service/error.service';
import {SharedService} from '../../../services/shared-service/shared.service';
import {ToastService} from '../../../util/toast-service/toast.service';


@Component({
  selector: 'app-transactions-configuration',
  templateUrl: './transactions-configuration.component.html',
  styleUrls: ['./transactions-configuration.component.scss']
})
export class TransactionsConfigurationComponent implements OnInit {
  pageTitle = 'Transactions Configuration';
  editCustomerLimit: boolean;
  customerLimitObj = {
    'airtimeLimit': null,
    'airtimeDailyLimit': null,
    'dataLimit': null,
    'dataDailyLimit': null
  };

  editGuestLimit: boolean;
  guestLimitObj = {
    'airtimeLimit': null,
    'airtimeDailyLimit': null,
    'dataLimit': null,
    'dataDailyLimit': null
  };

  customerAirtimeDailyLimit = null;
  customerAirtimeLimit = null;
  customerDataDailyLimit = null;
  customerDataLimit = null;
  isLoadingCustomerLimit = false;

  guestAirtimeDailyLimit = null;
  guestAirtimeLimit = null;
  guestDataDailyLimit = null;
  guestDataLimit = null;
  isLoadingGuestLimit = false;


  constructor(public userService: UserService, public router: Router,
              public authService: AuthService, public error: ErrorService, public sharedService: SharedService,
              public toast: ToastService) {
    this.sharedService.emitChange(this.pageTitle);
  }

  ngOnInit() {
    this.editCustomerLimit = false;
    this.getCustomerLimitConfig();

    this.editGuestLimit = false;
    this.getGuestLimitConfig();
  }

  public editCustomerConfig() {
    this.editCustomerLimit = true;
  }

  public cancelCustomerConfig() {
    this.editCustomerLimit = false;
    this.getCustomerLimitConfig(false);
  }

  public editGuestConfig() {
    this.editGuestLimit = true;
  }

  public cancelGuestConfig() {
    this.editGuestLimit = false;
    this.getGuestLimitConfig(false);
  }


  ////////////////// get customer limit config ////////////////////////////////////////////////////
  getCustomerLimitConfig = (newLoad = true) => {
    if (newLoad) {
      this.isLoadingCustomerLimit = true;
    }
    this.editCustomerLimit = false;

    this.userService.getCustomerLimitConfig().subscribe(
      response => {
        const limitResponse = response.data[0];

        this.customerAirtimeDailyLimit = limitResponse.airtimeDailyLimit;
        this.customerAirtimeLimit = limitResponse.airtimeLimit;
        this.customerDataDailyLimit = limitResponse.dataDailyLimit;
        this.customerDataLimit = limitResponse.dataLimit;
        this.isLoadingCustomerLimit = false;
      },
      err => {
        console.log(err);
        this.error.errorHandlerWithText(this.getCustomerLimitConfig, err);
        this.isLoadingCustomerLimit = false;
      }
    )
  }


  updateCustomerLimitConfig = () => {
    this.customerLimitObj.airtimeDailyLimit = this.customerAirtimeDailyLimit;
    this.customerLimitObj.airtimeLimit = this.customerAirtimeLimit;
    this.customerLimitObj.dataDailyLimit = this.customerDataDailyLimit;
    this.customerLimitObj.dataLimit = this.customerDataLimit;
    console.log(this.customerLimitObj);
    this.isLoadingCustomerLimit = true;
    this.userService.updateCustomerLimitConfig(this.customerLimitObj).subscribe(
      response => {
        console.log('config updated', response.data);
        this.getCustomerLimitConfig(false);
        this.toast.showSuccess('Customer Limit updated', 'Success');
      },
      err => {
        const error = this.error.errorHandlerWithText(this.updateCustomerLimitConfig, err);
        this.toast.showError(error.message, 'Validation Error');
        this.isLoadingCustomerLimit = false;
      }
    )
  }



  ////////////////// get guest limit config ////////////////////////////////////////////////////
  getGuestLimitConfig = (newLoad = true) => {
    if (newLoad) {
      this.isLoadingGuestLimit = true;
    }
    this.editGuestLimit = false;

    this.userService.getGuestLimitConfig().subscribe(
      response => {
        const limitResponse = response.data[0];

        this.guestAirtimeDailyLimit = limitResponse.airtimeDailyLimit;
        this.guestAirtimeLimit = limitResponse.airtimeLimit;
        this.guestDataDailyLimit = limitResponse.dataDailyLimit;
        this.guestDataLimit = limitResponse.dataLimit;
        this.isLoadingGuestLimit = false;
      },
      err => {
        console.log(err);
        this.error.errorHandlerWithText(this.getGuestLimitConfig, err);
        this.isLoadingGuestLimit = false;
      }
    )
  }


  updateGuestLimitConfig = () => {
    this.guestLimitObj.airtimeDailyLimit = this.guestAirtimeDailyLimit;
    this.guestLimitObj.airtimeLimit = this.guestAirtimeLimit;
    this.guestLimitObj.dataDailyLimit = this.guestDataDailyLimit;
    this.guestLimitObj.dataLimit = this.guestDataLimit;
    console.log(this.guestLimitObj);
    this.isLoadingGuestLimit = true;
    this.userService.updateGuestLimitConfig(this.guestLimitObj).subscribe(
      response => {
        console.log('config updated', response.data);
        this.getGuestLimitConfig(false);
        this.toast.showSuccess('Guest Limit updated', 'Success');
      },
      err => {
        const error = this.error.errorHandlerWithText(this.updateGuestLimitConfig, err);
        this.toast.showError(error.message, 'Validation Error');
        this.isLoadingGuestLimit = false;
      }
    )
  }

}



// WEBPACK FOOTER //
// ./src/app/Dashboard/DashboardPages/transactions-configuration/transactions-configuration.component.ts